import React from 'react'

import { Button } from '@cmsgov/design-system'

import { Modal } from '../Modal/Modal'
import { MessageInbox } from '../MessageInbox/MessageInbox'

import Message from '../../models/Message'

export interface MessageCenterModalProps {
  messages?: Message[];
  onMarkAllAsReadClick?: () => void;
  onViewMoreMessagesClick?: () => void;
  onClose: () => void;
}

export const MessageCenterModal: React.FC<MessageCenterModalProps> = ({
  messages = [],
  onMarkAllAsReadClick,
  onViewMoreMessagesClick,
  onClose
}) => (
  <Modal heading='My Messages' onClose={onClose}>
    <MessageInbox
      messages={messages}
      onMarkAllAsReadClick={onMarkAllAsReadClick}
    />
    <footer style={{ textAlign: 'center', padding: '1rem' }}>
      <Button onClick={onViewMoreMessagesClick} inverse>
        View More Messages
      </Button>
    </footer>
  </Modal>
)
